import { Page } from '@models/page';
import { MultiSelect, MultiSelectItem, useTranslation } from '@testsigma/atoms';
import { useEffect, useState } from 'react';
import { WdaSigninModel } from './wda-signin-model';
import WdaService from '@modules/settings/pages/ios-settings/components/profile/ios-wda-services';
import { WdaProfile } from '@models/wda-profile.model';

type WdaSelectionCompoentType = {
  setwdaSelection: Function;
  wdaId: number;
  setWdaId: Function;
};

export const WdaSelectionCompoent = (props: WdaSelectionCompoentType) => {
  const [wdaselection, setWdaselection] = useState<boolean>(false);
  const { t } = useTranslation();
  const [state, setState] = useState({
    selectedItem: '',
    selectedFilterId: null,
    wdaProfile: null,
  });

  const fetchData = () => {
    WdaService.findAll().then((data: Page<WdaProfile>) => {
      let value = '';
      for (const profile of data.content) {
        if (profile.id == props.wdaId) {
          value = profile.name;
        }
      }

      setState((prevState) => ({
        selectedItem: value,
        selectedFilterId: props.wdaId,
        wdaProfile: data,
      }));
    });
  };

  useEffect(() => {
    props.setwdaSelection(props.wdaId);
    fetchData();
  }, [props.wdaId]);

  const { selectedItem, selectedFilterId, wdaProfile } = state;

  return (
    <div className='flex flex-col gap-1'>
      {wdaselection && (
        <WdaSigninModel setOpen={setWdaselection} setWdaId={props.setWdaId} />
      )}
      <span className='text-xs leading-4 font-semibold text-secondary-500'>
        {t('upload.iosapp.title.linkwda')}
      </span>
      <div className='flex flex-row gap-4'>
        {wdaProfile?.content?.length > 0 && (
          <div className='w-1/2'>
            <MultiSelect
              name={
                selectedItem ? selectedItem : t('upload.iosapp.dropdown.show')
              }
              hideOnItemClick={true}>
              {wdaProfile?.content.map((item, idx) => {
                const isSelected = idx === selectedFilterId;
                return (
                  <MultiSelectItem
                    key={idx}
                    onClick={() => {
                      setState((prevState) => ({
                        ...prevState,
                        selectedItem: item.name,
                        selectedFilterId: idx,
                      }));
                      if (item.id) props.setwdaSelection(item.id);
                      else props.setwdaSelection(null);
                    }}
                    isSelected={isSelected}>
                    {item.name}
                  </MultiSelectItem>
                );
              })}
            </MultiSelect>
          </div>
        )}
        <span
          onClick={() => setWdaselection(true)}
          className={`w-1/2 inline-flex items-center text-sm text-primary-600 font-semibold cursor-pointer ${
            wdaProfile?.content?.length > 0 ? '' : 'py-2.5'
          }`}>
          {t('upload.iosapp.title.uploadnew')}
        </span>
      </div>
    </div>
  );
};
